import { styled, Box } from '@mui/material';

export const PublicNoteContainer = styled(Box)`
  min-height: 100vh;
  background: ${({ theme }) => theme.palette.background.default};
  width: 100%;
`;
